export const getDomain = email => {
  //eslint-disable-next-line
  if(!email) return null
  return email.split(`@`)[1]
}